import {
  styled,
  FormHelperText,
  createTheme,
  Paper,
  Grid,
  Box
} from "@mui/material";
import { Link } from "react-router-dom";
import { MenuButton as BaseMenuButton } from "@mui/base/MenuButton";
import { MenuItem as BaseMenuItem, menuItemClasses } from "@mui/base/MenuItem";
export const LinkTo = styled(Link)({ color: "white", textDecoration: "none" });
export const StarSymbol = styled("span")({ color: "rgb(211,56,86)" });
export const ErrorMessage = styled(FormHelperText)({
  color: "red",
  fontSize: "10px",
  marginBottom: 2
});

export const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2" // Primary color
    },
    secondary: {
      main: "#dc004e" // Secondary color
    },
    info: {
      main: "#17a2b8" // Info color
    },
    success: {
      main: "#28a745" // Success color
    },
    warning: {
      main: "#ffc107" // Warning color
    },
    error: {
      main: "#dc3545" // Error color
    },
    // Add custom colors if needed
    customBlue: {
      main: "#1e88e5",
      contrastText: "#ffffff" // Text color on this background
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 575,
      md: 768,
      lg: 991,
      xl: 1200
    }
  }
});

export const GridItem = styled("Box")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: { xs: "start", sm: "center" }
});
export const ButtonGrid = styled("Grid")({
  display: "flex",
  justifyContent: "end"
});
export const FormHelperTexts = styled(FormHelperText)({
  fontSize: "10px",
  marginBottom: "10px"
});

const blue = {
  50: "#F0F7FF",
  100: "#C2E0FF",
  200: "#99CCF3",
  300: "#66B2FF",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E6",
  700: "#0059B3",
  800: "#004C99",
  900: "#003A75"
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025"
};

export const Listbox = styled("ul")(
  ({ theme }) => `
   
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    box-sizing: border-box;
    padding: 6px;
    margin: 12px 0;
    
 margin: 5px 0;
  max-width: 200px; /* Prevent horizontal overflow */
    max-height: 200px; /* Limit height to enable scrolling */
    border-radius: 12px;
    overflow-y: auto; /* Enable vertical scrolling */
    overflow-x: hidden; /* Prevent horizontal scrolling */
    outline: 0;
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    box-shadow: 0 4px 6px ${
      theme.palette.mode === "dark" ? "rgba(0,0,0, 0.50)" : "rgba(0,0,0, 0.05)"
    };
    z-index: 1;

    /* Add a custom scrollbar style */
    scrollbar-width: thin; /* For Firefox */
    scrollbar-color: ${
      theme.palette.mode === "dark" ? grey[700] : grey[300]
    } transparent;

    &::-webkit-scrollbar {
      width: 6px; /* Width of the scrollbar */
    }

    &::-webkit-scrollbar-thumb {
      background: ${
        theme.palette.mode === "dark" ? grey[700] : grey[300]
      }; /* Scrollbar color */
      border-radius: 12px; /* Rounded corners */
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${
        theme.palette.mode === "dark" ? grey[600] : grey[400]
      }; /* Hover color */
    }

    &::-webkit-scrollbar-track {
      background: transparent; /* Track color */
    }
  `
);

export const MenuItem = styled(BaseMenuItem)(
  ({ theme }) => `
    list-style: none;
    padding: 8px;
    border-radius
    cursor: default;
    user-select: none;
    max-width: 150px; /* Prevent infinite width */
     
    &:last-of-type {
      border-bottom: none;
    }
  
    &:focus {
      outline: 3px solid ${
        theme.palette.mode === "dark" ? blue[600] : blue[200]
      };
      background-color: ${
        theme.palette.mode === "dark" ? grey[800] : grey[100]
      };
      color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    }
  
    &.${menuItemClasses.disabled} {
      color: ${theme.palette.mode === "dark" ? grey[700] : grey[400]};
    }
    `
);

export const StyledBox = styled(Box)(({ theme, isAuthenticated }) => ({
  flexGrow: 1,
  height: isAuthenticated ? "calc(100vh - 60px)" : "100vh",
  overflowY: "auto",
  backgroundColor: isAuthenticated ? "#f8f5f5" : "#ffffff"
}));
export const MenuButton = styled(BaseMenuButton)(
  ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.5;
    width:110px;
    max-width:110px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    background:#ccc;
    padding:7px 8px;
 
    transition: all 150ms ease;
    cursor: pointer;
    background: ${theme.palette.mode === "dark" ? grey[900] : "#ccc"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    color: ${theme.palette.mode === "dark" ? grey[200] : grey[900]};
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  
    &:hover {
      background: ${theme.palette.mode === "dark" ? grey[800] : grey[50]};
      border-color: ${theme.palette.mode === "dark" ? grey[600] : grey[300]};
    }
  
    &:active {
      background: ${theme.palette.mode === "dark" ? grey[700] : grey[100]};
    }
  
    &:focus-visible {
      box-shadow: 0 0 0 4px ${
        theme.palette.mode === "dark" ? blue[300] : blue[200]
      };
      outline: none;
    }
    `
);
export const formatDateWithAmPm = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return " - ";
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  };
  return new Intl.DateTimeFormat("en-US", options).format(date);
};

export const getStatusClass = (status) => {
  const statusClassMap = {
    Active: "badge-active",
    Approved: "badge-active",
    completed: "badge-active",
    Completed: "badge-active",
    Pending: "badge-pending",
    Inactive: "badge-inactive",
    Rejected: "badge-inactive",
    Receptionist: "badge-receptionist",
    Manager: "badge-manager",
    Failed: "badge-failed"
  };

  return statusClassMap[status] || "badge-default";
};

// export const columnFetcher = (column) => {
//   const columns = column[0];
//   const column_name = Object.keys(columns);
//   const value = column_name.map((name) => name);
//   const label = column_name.map((name) =>
//     name.toUpperCase().replaceAll("_", " ")
//   );

//   return [value, label];
// };

export const columnFetcher = (column) => {
  if (!Array.isArray(column) || column.length === 0) {
    return [];
  }

  const columns = column[0];
  const columnNames = Object.keys(columns);

  return columnNames.map((name) => ({
    value: name,
    label: name.toUpperCase().replaceAll("_", " ")
  }));
};

export const customerColumnFetcher = (customers) => {
  if (!customers || customers.length === 0) {
    return [];
  }

  const columns = Object.keys(customers[0]);
  return columns.map((key) => {
    const formattedKey = key
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (match) => match.toUpperCase());

    return {
      value: key,
      label: formattedKey
    };
  });
};

export const vendorColumnFetcher = (vendors) => {
  if (!vendors || vendors.length === 0) {
    return [];
  }

  const columns = Object.keys(vendors[0]);
  return columns.map((key) => {
    const formattedKey = key
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (match) => match.toUpperCase());

    return {
      value: key,
      label: formattedKey
    };
  });
};

export const airportColumnFetcher = (airports) => {
  if (!airports || airports.length === 0) {
    return [[], []];
  }

  const columns = airports[0];
  const columnNames = Object.keys(columns);
  const values = columnNames.map((name) => name);
  const labels = columnNames.map((name) =>
    name.toUpperCase().replaceAll("_", " ")
  );

  return [values, labels];
};

export const formatDatetimeWithAMPM = (datetimeString) => {
  const date = new Date(datetimeString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${hours
    .toString()
    .padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
};

export const handleApiError = (error) => {
  if (error.response) {
    const errorData = error.response.data || {};
    const errorFields = errorData.errorFields || {};
    return {
      statusCode: error.response.status,
      email: errorFields.email || null,
      phone: errorFields.phone || null,
      contact: errorFields.contact || null,
      additionalErrors: errorFields,
      message: errorData.message || "Unknown error occurred."
    };
  } else if (error.request) {
    return {
      statusCode: null,
      message: "No response received from the server. Please try again later."
    };
  } else {
    return {
      statusCode: null,
      message: error.message || "An unexpected error occurred."
    };
  }
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
